<template>
  <div>
    <div v-if="collapse && item != null" class="info-panel">
      <div class="row">
        <div class="col-12 mb-3">
          <em class="fas fa-info-circle text-orange mr-1" />
          <span>Información del Estudiante</span>
        </div>
        <div class="col-12 mx-4">
          <div class="row">
            <div class="col-sm">
              <span class="data-label">Impedimento:</span>
              <p class="data">{{ item.impediment }}</p>
            </div>
            <div class="col-sm">
              <span class="data-label">Escuela:</span>
              <p class="data">
                {{ item.schoolCode }} -
                {{ item.school }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-12 mb-3">
          <em class="fas fa-info-circle text-orange mr-1" />
          <span>Información de Servicio</span>
        </div>
        <div class="col-12 mx-4">
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-3">
              <span class="data-label">Desde:</span>
              <p class="data">
                {{ (item != null ? item.dateFrom : "") | formatDate }}
              </p>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3">
              <span class="data-label">Inicial:</span>
              <p class="data">{{ item.initialDate | date }}</p>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3">
              <span class="data-label">Proveedor:</span>
              <p class="data">{{ item.providerName || "-" }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-3">
              <span class="data-label">Hasta:</span>
              <p class="data">{{ item.dateTo | date }}</p>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3">
              <span class="data-label">Admisión:</span>
              <p class="data">{{ item.admissionDate | date }}</p>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3">
              <span class="data-label">Lugar de Servicio:</span>
              <p class="data">{{ studentInfo.locationName || "-" }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-3">
              <span class="data-label">Referido:</span>
              <p class="data">{{ item.referralDate | date }}</p>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3">
              <span class="data-label">Última visita:</span>
              <p class="data">{{ item.lastDateVisit | date }}</p>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3">
              <span class="data-label">Especialista de Admisión:</span>
              <p class="data">{{ item.admissionSpecialist || "-" }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-3">
              <span class="data-label">Vinculado:</span>
              <p class="data">{{ item.linkedDate | date }}</p>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3">
              <span class="data-label">Contacto:</span>
              <p class="data">
                <label>
                  {{ item.contact }}
                  <br />
                  {{ item.contactTelephone }}
                  <br />
                  {{ item.contactEmail }}
                </label>
              </p>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3">
              <span class="data-label">Especialista de Servicio:</span>
              <p class="data">{{ item.serviceSpecialist || "-" }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-3">
              <span class="data-label">Tipo de Referido:</span>
              <p class="data">{{ item.admissionCreationReason }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col mr-4">
              <span class="data-label">Razón de Servicio:</span>
              <p class="data">{{ studentInfo.serviceReason | empty }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div v-if="actionPlanComments.length > 0" class="info-panel-item">
            <span>Plan de Acción:</span>
            <ul>
              <li
                v-for="(comment, index) in actionPlanComments"
                :key="`${index}_${studentInfo.admissionId}`"
              >
                {{ comment }}
              </li>
            </ul>
          </div>
        </div>
        <div class="col">
          <div v-if="breachReasonComments.length > 0" class="info-panel-item">
            <span>Documentación Incumplimiento:</span>
            <ul>
              <li
                v-for="(comment, index) in breachReasonComments"
                :key="`${index}_${studentInfo.admissionId}`"
              >
                {{ comment }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
const CUSTOM_DATE_FORMAT = "DD/MMM/YYYY";
import { CustomDropDown } from "@/components/common";
import commentTypes from "@/utils/constants/comment/codeAdmissionCommentTypes";

export default {
  name: "ReferralAdditionalInfo",
  data() {
    return {
      collapse: false,
      currentCenterValue: {},
      currentCenter: {},
    };
  },
  components: {
    CustomDropDown,
  },
  filters: {
    formatDate: (date) => {
      if (date) {
        return moment(date).locale("es").format(CUSTOM_DATE_FORMAT);
      }
      return "";
    },
  },
  computed: {
    comments() {
      return this.studentInfo.comments;
    },
    actionPlanComments() {
      return this.comments
        .filter((x) => x.commentTypeCode === commentTypes.PlanAccion)
        .map((x) => x.commentDesc);
    },
    breachReasonComments() {
      return this.comments
        .filter((x) => x.commentTypeCode === commentTypes.RazonIncumplimiento)
        .map((x) => x.commentDesc);
    },
  },
  methods: {
    collapseItem() {
      this.collapse = !this.collapse;
      this.$emit("on-collapse", this.collapse);
    },
    onChangeCenter(value) {
      this.item.currentCenter = value;
      this.$emit("on-change-center", {
        center: {
          ...value,
        },
        item: this.studentInfo,
      });
    },
  },
  watch: {
    isDetailsOpened(newVal, oldVal) {
      if (newVal != oldVal) {
        this.collapse = newVal;
      }
    },
  },
  props: {
    item: {
      type: Object,
      default: () => ({
        impediment: "",
        referralDate: "",
        dateFrom: "",
        linkedDate: "",
        school: "",
        initialDate: "",
        dateTo: "",
        admissionDate: "",
        contact: "",
        contactTelephone: "",
        contactEmail: "",
        asigment: "",
        lastDateVisit: "",
        admissionSpecialist: "",
        billingCenterId: "",
        billingCenterName: "",
        schoolCode: "",
        school: "",
      }),
    },
    studentInfo: {
      type: Object,
      default: () => {},
    },
    isDetailsOpened: {
      type: Boolean,
      default: () => false,
    },
    centers: {
      type: Array,
      default: () => [],
    },
    selectedCenter: {
      type: Object,
      default: () => {},
    },
    canChangeBillingCenter: {
      type: Boolean,
      default: () => false,
    },
  },
  mounted() {
    this.collapse = this.isDetailsOpened;
  },
};
</script>

<style scoped lang="scss">
$collapseOpenColor: #bcbec0;
$collapseCloseColor: #ff7058;
$colorWhite: #fff;
$panelBorderColor: #f2f2f2;

.separator-additional-info {
  display: flex;
  align-items: center;
  text-align: center;
  color: $colorWhite;
  height: 5px;
  justify-content: center;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  &.up {
    background: $collapseCloseColor;
  }
  &.down {
    background: $collapseOpenColor;
  }
  font: 700 14px/17px Lato;
  .title-container {
    border-radius: 21px;
    padding: 5px 16px 8px 16px;
    color: $colorWhite;
    &.up {
      background: $collapseCloseColor;
    }
    &.down {
      background: $collapseOpenColor;
    }
    em {
      margin-right: 10px;
      font-weight: bold;
    }
    &:hover {
      cursor: pointer;
    }
  }
}
.info-panel {
  .info-panel-main-title {
    em {
      color: $collapseCloseColor;
    }
    span {
      text-align: left;
      font: Bold 16px/19px Lato;
      letter-spacing: 0px;
      color: #3f5b60;
      opacity: 1;
      margin-left: 7px;
    }
  }
  .info-panel-container {
    display: flex;
    flex-flow: row wrap;
    padding: 15px 10px 1px 23px;
    .info-panel-item {
      flex: 1 0 25%;
      margin-bottom: 1.5em;
      float: left;
      box-sizing: border-box;
      padding-right: 10px;
      span {
        display: block;
        text-align: left;
        font: Regular 14px/28px Lato;
        letter-spacing: 0px;
        color: #727272;
      }
      label {
        margin-top: 10px;
        text-align: left;
        font: Regular Lato;
        font-size: 1rem;
        letter-spacing: 0px;
        color: #11291b;
        line-height: 1.6em;
      }
    }
  }
}
.csee-custom-width {
  max-width: 12rem;
}
</style>
